import { Message } from 'element-ui';
import Axios from '@/utils/Axios'
import appConfig from '@/config/app.js'
import store from '@/utils/store'

export default {
    //请求拦截处理方法
    reqHandle(config) {
        const token = store.get('token');
        // console.log(token, config.data)
        token && (config.headers.AdminAuthorization = 'Bearer ' + token);
        // console.log(config)
        return config;
    },

    //请求错误处理方法
    reqErrorHandle(error) {
        // if (modal!==false){
        //     modal.destroy();
        // }

        Message.error({
            message: '请求失败'
        });
        return Promise.reject(error);
    },

    //响应成功处理方法
    resHandle(response) {
        try {
            const { data, status } = response.data;
            let msg = Object.prototype.hasOwnProperty.call(response.data, 'msg') ? response.data.msg : '未知错误';
            switch (status) {
                case 200://请求成功
                    // console.log('响应成功:', response.data);
                    return data;
                case 401://鉴权失败
                    store.delete('token');//删除token
                    window.location.href = '/login';
                    break;
                case 404://资源未找到
                    msg = '接口地址不存在！';
                    break;
                case 406://验证失败
                    store.delete('token');//删除token
                    window.location.href = '/login';
                    break;
            }


            if (status !== 401) {
                Message.error({
                    message: msg
                });
            }

            return Promise.reject(response.data);
        } catch (err) {
            // console.log(err);
            // window.location.href = '/error_page';
        }
    },

    //响应失败处理默认方法
    resErrorHandle(error) {
        try {
            // console.log(error.response);
            // const { data, status } = error.response;
            // let msg = Object.prototype.hasOwnProperty.call(data, 'msg') ? data.msg : '未知错误';

            // Message.error({
            //     message: msg
            // });

            return Promise.reject(error);
        } catch (err) {
            // console.log(err);
            // window.location.href = '/error_page';
        }
    },

    //vue插件install方法
    install(Vue) {
        const axios = new Axios({
            timeout: appConfig.api.timeout * 1000,
            base_url: appConfig.api.base_url,
            reqFuc: this.reqHandle,
            reqErrFuc: this.reqErrorHandle,
            resFuc: this.resHandle,
            resErrFuc: this.resErrorHandle
        });

        //rpc请求方法
        const invoke = (fuc, params, { ...config }) => {
            return axios.post('', {
                data: {
                    f: fuc,
                    p: [params]
                },
                ...config
            })
        };


        //注册全局快捷方法
        Vue.$_ajax = axios.getInstance;
        Vue.$_get = axios.get;
        Vue.$_post = axios.post;
        Vue.$_delete = axios.delete;
        Vue.$_put = axios.put;
        Vue.$_patch = axios.patch;
        Vue.$_invoke = invoke;

        //注册实例快捷方法
        Vue.prototype.$_ajax = axios.getInstance;
        Vue.prototype.$_get = axios.get;
        Vue.prototype.$_post = axios.post;
        Vue.prototype.$_delete = axios.delete;
        Vue.prototype.$_put = axios.put;
        Vue.prototype.$_patch = axios.patch;
        Vue.prototype.$_invoke = invoke;

        const axios2 = new Axios({
            timeout: appConfig.api.timeout * 1000,
            base_url: "http://"+appConfig.websocket_url,
            reqFuc: this.reqHandle,
            reqErrFuc: this.reqErrorHandle,
            resFuc: this.resHandle,
            resErrFuc: this.resErrorHandle
        });

        //rpc请求方法
        const invoke2 = (fuc, params, { ...config }) => {
            return axios2.post('', {
                data: {
                    f: fuc,
                    p: [params]
                },
                ...config
            })
        };

        Vue.prototype.$_invoke2 = invoke2;
    }
}